export default "__VITE_ASSET__Dtlb9lvu__"